// 引入二次封装
import request from "@/utils/request.js";

// // 导出get请求的接口方法
// export function myget(params) {
//   return request({
//     url: "xxx",
//     method: "get",
//     params,
//   });
// }

// // 导出post请求的接口方法
// export function mypost(data) {
//   return request({
//     url: "xxx",
//     method: "post",
//     data,
//   });
// }

// 获取文章列表
export function articleList(data) {
  return request({
    url: "/api/article/index",
    method: "post",
    data,
  });
}

// 获取文章详情
export function articleInfo(data) {
  return request({
    url: "/api/article/info",
    method: "post",
    data,
  });
}

// 获取文章详情
export function fractionList(data, token) {
  return request({
    url: "/api/article/fraction_list",
    method: "post",
    data,
    headers: { token },
  });
}

// 首页悬浮组件接口
export function configFloating(params) {
  return request({
    url: "/api/config/floating",
    method: "get",
    params,
  });
}

// 图书纠错
export function bookError(data) {
  return request({
    url: "/api/common/book_error",
    method: "post",
    data,
  });
}

// 图书反馈
export function bookFeedback(data) {
  return request({
    url: "/api/common/book_feedback",
    method: "post",
    data,
  });
}

// 正版验证
export function checkBook(data) {
  return request({
    url: "/api/common/check_book",
    method: "post",
    data,
  });
}

// // 分数线选择项
// export function fractionSelectOption(params) {
//   return request({
//     url: "/api/article/fraction_select_option",
//     method: "get",
//     params,
//   });
// }

// 分数线地区
export function fractionArea(params) {
  return request({
    url: "/api/article/fraction_area",
    method: "get",
    params,
  });
}

// 分数线年份
export function fractionYear(params) {
  return request({
    url: "/api/article/fraction_year",
    method: "get",
    params,
  });
}

// 考生分类
export function fractionClass(params) {
  return request({
    url: "/api/article/fraction_class",
    method: "get",
    params,
  });
}

// 录取批次
export function fractionBatch(params) {
  return request({
    url: "/api/article/fraction_batch",
    method: "get",
    params,
  });
}

// 录取批次
export function homeComprehensive(params) {
  return request({
    url: "/api/common/home_comprehensive",
    method: "get",
    params,
  });
}

// 获取活动关键字
export function activityKeyword(data) {
  return request({
    url: "/api/article/activity_keyword",
    method: "post",
    data,
  });
}


// 获取活动关键字
export function onlineStudyClass(params) {
  return request({
    url: "/api/article/online_study_class",
    method: "get",
    params,
  });
}



// 获取活动关键字
export function onlineStudyCondition(params) {
  return request({
    url: "/api/article/online_study_condition",
    method: "get",
    params,
  });
}
